/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Port } from './Port';
import {
    PortFromJSON,
    PortFromJSONTyped,
    PortToJSON,
} from './Port';
import type { PortHistoryNameGet200ResponseRecordsInnerAllOfShip } from './PortHistoryNameGet200ResponseRecordsInnerAllOfShip';
import {
    PortHistoryNameGet200ResponseRecordsInnerAllOfShipFromJSON,
    PortHistoryNameGet200ResponseRecordsInnerAllOfShipFromJSONTyped,
    PortHistoryNameGet200ResponseRecordsInnerAllOfShipToJSON,
} from './PortHistoryNameGet200ResponseRecordsInnerAllOfShip';

/**
 * 
 * @export
 * @interface PortHistoryNameGet200ResponseRecordsInner
 */
export interface PortHistoryNameGet200ResponseRecordsInner {
    /**
     * Actual Time of Arrival [UTC]
     * @type {Date}
     * @memberof PortHistoryNameGet200ResponseRecordsInner
     */
    ata?: Date;
    /**
     * Actual Time of Departure [UTC]
     * @type {Date}
     * @memberof PortHistoryNameGet200ResponseRecordsInner
     */
    atd?: Date;
    /**
     * 
     * @type {Port}
     * @memberof PortHistoryNameGet200ResponseRecordsInner
     */
    port?: Port;
    /**
     * 
     * @type {PortHistoryNameGet200ResponseRecordsInnerAllOfShip}
     * @memberof PortHistoryNameGet200ResponseRecordsInner
     */
    ship?: PortHistoryNameGet200ResponseRecordsInnerAllOfShip;
}

/**
 * Check if a given object implements the PortHistoryNameGet200ResponseRecordsInner interface.
 */
export function instanceOfPortHistoryNameGet200ResponseRecordsInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PortHistoryNameGet200ResponseRecordsInnerFromJSON(json: any): PortHistoryNameGet200ResponseRecordsInner {
    return PortHistoryNameGet200ResponseRecordsInnerFromJSONTyped(json, false);
}

export function PortHistoryNameGet200ResponseRecordsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortHistoryNameGet200ResponseRecordsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ata': !exists(json, 'ata') ? undefined : (new Date(json['ata'])),
        'atd': !exists(json, 'atd') ? undefined : (new Date(json['atd'])),
        'port': !exists(json, 'port') ? undefined : PortFromJSON(json['port']),
        'ship': !exists(json, 'ship') ? undefined : PortHistoryNameGet200ResponseRecordsInnerAllOfShipFromJSON(json['ship']),
    };
}

export function PortHistoryNameGet200ResponseRecordsInnerToJSON(value?: PortHistoryNameGet200ResponseRecordsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ata': value.ata === undefined ? undefined : (value.ata.toISOString()),
        'atd': value.atd === undefined ? undefined : (value.atd.toISOString()),
        'port': PortToJSON(value.port),
        'ship': PortHistoryNameGet200ResponseRecordsInnerAllOfShipToJSON(value.ship),
    };
}

